import { render } from "./AlertsPage.vue?vue&type=template&id=aae12a3e&ts=true"
import script from "./AlertsPage.vue?vue&type=script&lang=ts"
export * from "./AlertsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__